import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { hasCurrentUserErrors } from '../../ducks/user.duck';
import { logout, authenticationInProgress, loginWithDecathlon } from '../../ducks/Auth.duck';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import { Topbar } from '../../components';

export const TopbarContainerComponent = props => {
  const {
    authInProgress,
    currentPage = null,
    currentSearchParams = null,
    currentUser,
    currentUserHasListings,
    currentUserProviderId,
    currentUserHasOrders = null,
    history,
    isAuthenticated,
    authScopes = null,
    hasGenericError,
    location,
    notificationCount = 0,
    onLogout,
    onDktLogin,
    onManageDisableScrolling,
    promo,
    numberOfCartPreorders,
    sendVerificationEmailInProgress,
    sendVerificationEmailError = null,
    onResendVerificationEmail,
    awaitingTransactionIds,
    numberOfPendingServiceFee,
    ...rest
  } = props;

  return (
    <Topbar
      authInProgress={authInProgress}
      currentPage={currentPage}
      currentSearchParams={currentSearchParams}
      currentUser={currentUser}
      currentUserHasListings={currentUserHasListings}
      currentUserProviderId={currentUserProviderId}
      currentUserHasOrders={currentUserHasOrders}
      history={history}
      isAuthenticated={isAuthenticated}
      authScopes={authScopes}
      location={location}
      notificationCount={notificationCount}
      onLogout={onLogout}
      onDktLogin={onDktLogin}
      onManageDisableScrolling={onManageDisableScrolling}
      onResendVerificationEmail={onResendVerificationEmail}
      promo={promo}
      sendVerificationEmailInProgress={sendVerificationEmailInProgress}
      sendVerificationEmailError={sendVerificationEmailError}
      showGenericError={hasGenericError}
      numberOfCartPreorders={numberOfCartPreorders}
      numberOfPendingServiceFee={numberOfPendingServiceFee}
      awaitingTransactionIds={awaitingTransactionIds}
      {...rest}
    />
  );
};

const mapStateToProps = state => {
  const { isAuthenticated, logoutError, authScopes } = state.Auth;
  const { isPromoOn, code, discount, discountedCategories, title } = state.Promo;
  const {
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    userProviders,
    currentUserNotificationCount: notificationCount,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    awaitingTransactionIds,
    numberOfPendingServiceFee,
    numberOfCartPreorders
  } = state.user;
  const hasGenericError = !!(logoutError || hasCurrentUserErrors(state));

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    currentUserHasListings,
    currentUserProviderId: userProviders && !!userProviders.length && userProviders[0].id.uuid,
    currentUserHasOrders,
    notificationCount,
    isAuthenticated,
    authScopes,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    hasGenericError,
    promo: { isPromoOn, code, discount, discountedCategories, title },
    numberOfCartPreorders,
    awaitingTransactionIds,
    numberOfPendingServiceFee,
  };
};

const mapDispatchToProps = dispatch => ({
  onLogout: historyPush => dispatch(logout(historyPush)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onDktLogin: () => dispatch(loginWithDecathlon())
});

const TopbarContainer = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TopbarContainerComponent);

export default TopbarContainer;
